import { render, staticRenderFns } from "./yibiao.vue?vue&type=template&id=0f6e97dc&scoped=true&"
import script from "./yibiao.vue?vue&type=script&lang=js&"
export * from "./yibiao.vue?vue&type=script&lang=js&"
import style0 from "./yibiao.vue?vue&type=style&index=0&id=0f6e97dc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6e97dc",
  null
  
)

export default component.exports